import client from "./client";
import { PayrollBatchSummary, ProcessPayrollResponse } from "../interfaces/PayrollBatchInterface";

function getErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const r = (err as { response?: { data?: { message?: string } } }).response;
    if (r?.data?.message) return r.data.message;
  }
  if (err instanceof Error) return err.message;
  return "Request failed";
}

export async function getPayrollBatches(year: number): Promise<PayrollBatchSummary[]> {
  const response = await client.get<PayrollBatchSummary[]>("admin/payroll/batches", {
    params: { year },
  });
  return response.data;
}

export async function processPayroll(payPeriodID: number): Promise<ProcessPayrollResponse> {
  try {
    const response = await client.post<ProcessPayrollResponse>("admin/payroll/process", { payPeriodID });
    return response.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}
